import { render, staticRenderFns } from "./PageFAQ.vue?vue&type=template&id=4fcaf83d&scoped=true"
import script from "./PageFAQ.vue?vue&type=script&lang=ts"
export * from "./PageFAQ.vue?vue&type=script&lang=ts"
import style0 from "./PageFAQ.vue?vue&type=style&index=0&id=4fcaf83d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcaf83d",
  null
  
)

export default component.exports